import { State } from 'xstate';

import { StateEvent } from '../constants/eventTypes';
import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
  ProductBuilderMachineStateSchema,
} from '../types';
import { getEventFromState } from './getEventFromState';
import { getNextState } from './getNextState';
import { isFinalState } from './isFinalState';
import { stateHasValue } from './stateHasValue';

type GoToNextState = (
  state: State<
    ProductBuilderMachineContext,
    ProductBuilderMachineEvent,
    ProductBuilderMachineStateSchema
  >,
  send: (event: StateEvent) => void,
) => () => void;

export const goToNextState: GoToNextState = (state, send) => () => {
  if (
    isFinalState(state) ||
    !stateHasValue(state) ||
    state.matches('measurements.loading')
  )
    return;
  const nextState = getNextState(state);
  const nextStateEvent = getEventFromState(nextState);
  send(nextStateEvent);
};
